export default __webpack_public_path__ + "static/media/image4.26476a8e.png";